
import { FormRow, TextInput } from '@curtin-dxp/ui';
export const GCEALevelExaminationDateSelect = (props) => {
        return ( 
              <FormRow>
                <TextInput  id="gceALevelExamDate" label="Examination Date" onChange={props.onChange} value={props.gceALevelExamDate} placeholder="e.g., 10/11 2026 or Oct/Nov 2026" required maxLength={50} />   
              </FormRow> 
       );
   }